/**
 * Build-time runtime configuration for the kiosk PWA, read once from the typed
 * `import.meta.env` (see vite-env.d.ts). No Entra values — this is a device app.
 */

/** WorkLogix API origin. Trailing slash is tolerated by the API client. */
export const API_BASE: string = import.meta.env.VITE_API_BASE;

/** This bundle's build id; drives the version-check refresh banner. */
export const BUILD_ID: string = import.meta.env.VITE_BUILD_ID;

/**
 * Soft clock-skew threshold. If the device clock differs from the server clock
 * by more than this on load, we warn the operator — client-supplied `punchedAt`
 * drives payroll, so a wrong device clock silently corrupts hours.
 */
export const SKEW_WARN_THRESHOLD_MS = 120_000;
